import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CricketScoreCard' */ './CricketScoreCard'),
  loading: () => null,
});

export default class CricketScoreCardLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, 1000);
  }
  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} />;
  }
}
